import { type FormEvent } from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (value: string) => void;
}

export default function SearchBar({ value, onChange, onSubmit }: SearchBarProps) {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(value.trim());
  };

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className="flex items-center gap-2 h-12 md:h-14 pl-4 md:pl-5 pr-1.5 md:pr-2 rounded-full bg-background-50 border border-background-200 focus-within:border-primary-400 transition-colors"
    >
      <div className="w-5 h-5 flex items-center justify-center shrink-0">
        <i className="ri-search-line text-lg text-foreground-500"></i>
      </div>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="搜索产品、解决方案、客户案例、公司资料"
        className="flex-1 min-w-0 bg-transparent text-sm md:text-base text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
        aria-label="站内搜索"
      />
      <button
        type="submit"
        className="h-9 md:h-11 px-4 md:px-6 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
      >
        搜索
      </button>
    </form>
  );
}